define([], function () {
	'use strict';

	/**
	 * Abstract MainView class
	 */
	return function () {

		this.get = function () {
			throw new Error('not implemented');
		};

		this.setTitle = function (title) {
			throw new Error('not implemented');
		};

		this.setControls = function (controls) {
			throw new Error('not implemented');
		};

		this.clearBody = function () {
			throw new Error('not implemented');
		};

		this.appendToBody = function (content) {
			throw new Error('not implemented');
		};

		this.show = function (animate, callbacks) {
			throw new Error('not implemented');
		};

		this.hide = function (animate, callbacks) {
			throw new Error('not implemented');
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/MainView.js
// module id = 70
// module chunks = 1